import { z } from 'zod'

export const datadogSiteSchema = z.enum([
  'datadoghq.eu',
  'datadoghq.com',
  'us3.datadoghq.com',
  'us5.datadoghq.com',
  'ap1.datadoghq.com',
  'ap2.datadoghq.com',
  'ddog-gov.com',
  'us2.ddog-gov.com',
])

export type DatadogSite = z.infer<typeof datadogSiteSchema>

// Matches @datadog/browser-core's buildEndpointHost for RUM, logs and replay.
export function getDatadogIntakeSources(site: DatadogSite): string[] {
  const parts = site.split('.')
  const extension = parts.pop()
  const host = `browser-intake-${parts.join('-')}.${extension}`
  return [host, `*.${host}`]
}

export function resolveBrowserDatadogConfiguration(
  environment: string,
  env: Partial<NodeJS.ProcessEnv>,
) {
  const site = datadogSiteSchema.parse(env.NEXT_PUBLIC_DATADOG_SITE ?? 'datadoghq.eu')
  const useLegacyDefaults = environment === 'prod' && site === 'datadoghq.eu'
  return {
    DATADOG_SITE: site,
    DATADOG_APPLICATION_ID:
      env.NEXT_PUBLIC_DATADOG_APPLICATION_ID ||
      env.DATADOG_APPLICATION_ID ||
      (useLegacyDefaults ? '1b281e0f-8e0c-445c-8be7-1db7091336b0' : ''),
    DATADOG_CLIENT_TOKEN:
      env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN ||
      env.DATADOG_CLIENT_TOKEN ||
      (useLegacyDefaults ? 'pubaf88cfa29f110038d293bae5fc2608bb' : ''),
  }
}
